import { render, staticRenderFns } from "./Assignments.container.vue?vue&type=template&id=45bc4401&scoped=true&"
import script from "./Assignments.container.vue?vue&type=script&lang=js&"
export * from "./Assignments.container.vue?vue&type=script&lang=js&"
import style0 from "./Assignments.container.vue?vue&type=style&index=0&id=45bc4401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bc4401",
  null
  
)

export default component.exports